/* eslint-disable max-len */
import React from "react"
import { useState,useEffect ,useContext} from "react";
import { dataService } from "../../../../services/data.services";
import { CDN } from "../../../../config"
import { useSelector } from "react-redux";
import moment from "moment";
import GlobalContext from "../../../../components/Context/GloablContext";
import { convertEpochToDateFormat } from "../../../../CommonMethods/DateConversion";
import CustomOverLay from "../../../../components/CustomOverLay";
import Loader from "../../../../components/Loader";
import { BeatLoader } from "react-spinners";
export default function ViewPatientDevices({patient_id}){
    const { isSideBar } = useContext(GlobalContext);
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const dateformat = useSelector(state => state?.systemConfigData?.globalVariables?.date_format)
    useEffect(() => {
        fetchData('initial');
        
    }, []);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [isLoading]);

    const fetchData = async(isInitial) => {
        if (!hasMore) return;
        setIsLoading(true);
        try{
            const res = await dataService.GetAPI(`patients/list-linked-devices/${patient_id}?page_number=${page}&limit=15`)
            if(res.data.status===200){
                if (res?.data?.data?.data?.length === 0) {
                    setIsLoading(false)
                    setHasMore(false); // No more data available
                }
                setItems(prevItems=>[...prevItems,...res?.data?.data?.data])
                setPage(prevPage => prevPage + 1);
                setIsLoading(false);
            }
        }catch(error){
            setIsLoading(false);
        }
       
    };
    
    const handleScroll = () => {
        
        if (((document.getElementById('device_scrollarea').scrollTop+document.getElementById('device_scrollarea')?.clientHeight) !== (document.getElementById('device_scrollarea')?.scrollHeight)) || isLoading) {
            return;
        }
        fetchData();
    };

    const handleDevicestatus = (key,device) => {
        let val = {}
       
        switch (device?.status) {
        case "active":
            val = { classKey: "bg-[#CCE7E7]  text-[#006A6B]", text : "Active"}
            break;
        case "out-of-service":
            val = { classKey: "bg-[#EEB9BC] text-[#C81720]" , text : "Out of Service"}
            break;
        case "retired":
            val = { classKey: "bg-[#C5C9DA]  text-[#52555D]", text : "Retired" }
            break;

        default:
            break;
        }
        return val[key];

    }
   
    return(
        <div  className="pt-[30px]" >
            <div id={"device_scrollarea"} className="h-[calc(100vh-382px)] overflow-auto scrollbar_gray"  onScroll={handleScroll}>
                {items.length===0&&isLoading?<CustomOverLay Active text="Loading Device details..." classKey={`ml-[30px] top-0 left-0 right-20  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar ? ('opened_sidebar_device_patient') : 'sidebar_device_patient'}`} />:
                    items?.map((device)=>(<div key={device._id}>
                        <div className="pb-[20px] px-[28px]">
                            <div className=" bg-[#E7EAF4] rounded-lg px-10 pt-[30px] pb-[22px]">
                                <div>
                                    <div className="w-full flex justify-between">
                                        <div className="w-[25%]">
                                            <div className=" mb-[30px] ">
                                                {device?.image_url !== "" ?
                                                    <img className=" border-2 border-dashed border-[#972E4C] bg-white py-10 w-[350px] xl:h-[250px] h-[180px] rounded-[10px] px-4" src={`${CDN}${device?.image_url}`} alt="device-image" /> :
                                                    <div className='relative'>
                                                        <img className=" border-2 border-dashed border-[#972E4C] bg-white py-10 w-[350px] xl:h-[250px] h-[180px] rounded-[10px] px-4" src={'/images/empty-image.svg'} alt="device-image" />
                                                        <p className='absolute text-[12px] font-normal text-[#52555D] bottom-[15px] w-full text-center '>No Image Uploaded</p>
                                                    </div>}
                                            </div>
                                            <div className="w-full mb-[30px]">
                                                <p className="text-sm font-normal text-[#000]">Created</p>
                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                    {(device?.created_at===''||device?.created_at===null)?'-':convertEpochToDateFormat(device?.created_at, dateformat)}</p>
                                            </div>
                                            <div className="w-full mb-[30px]">
                                                <p className="text-sm font-normal text-[#000]">Assigned</p>
                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                    {(device?.assigned_at===''||device?.assigned_at===null)?'-':convertEpochToDateFormat(device?.assigned_at, dateformat)}</p>
                                            </div>
                                            <div className="w-full mb-[30px]">
                                                <p className="text-sm font-normal text-[#000]">Initial Reading Timestamp</p>
                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                    {(device.initial_reading_timestamp===''||device.initial_reading_timestamp===null)?'-':convertEpochToDateFormat(device?.initial_reading_timestamp,dateformat)}</p>
                                            </div>

                                        </div>
                                        <div className="w-[75%]">
                                            <div className="flex  mb-[30px]">
                                                <div className="w-1/3 px-6">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Device Template</p>
                                                        <p className="text-base capitalize text-normal text-[#000B17] pt-2 break-words">
                                                            {device?.device_template!== "" ? device?.device_template: '-'}</p>
                                                    </div>
                                                </div>
                                                <div className="w-1/3 px-6">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Device ID</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {device?.device_id !== "" ? device?.device_id : '-'}</p>
                                                    </div>
                                                </div>
                                                <div className="w-1/3 px-6">
                                                    <div className="w-full">
                                                        <p id="status" className={`text-sm rounded-[24px] ${handleDevicestatus("classKey",device)} py-1.5 px-3.5 w-fit font-semibold`}>
                                                            {handleDevicestatus("text",device)}</p>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="w-full px-6 mb-[30px]">
                                                <p className="text-sm font-normal text-[#000]">Reading Type</p>
                                                {device?.reading_type && device?.reading_type.length > 0 ?
                                                    <p className="text-base capitalize text-normal text-[#000B17] pt-2 break-words">
                                                        {/* {device.reading_type.join(', ')} */}
                                                        {[device?.reading_type] &&
                                                                typeof [device?.reading_type] === 'string'
                                                            ? [device?.reading_type].replace(/[_-]/g, " ")
                                                            : ([device?.reading_type ]|| '').toString().replace(/[_-]/g, " ")}
                                                    </p>
                                                    :
                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                        -
                                                    </p>
                                                }
                                            </div>
                                            <div className="flex  mb-[30px]">
                                                <div className="w-1/3 px-6">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Device Manufacturer </p>
                                                        <p className="text-base capitalize text-normal text-[#000B17] pt-2 break-words">
                                                            {device?.manufacturer_name !== "" ? device?.manufacturer_name : '-'}</p>
                                                    </div>
                                                </div>
                                                <div className="w-1/3 px-6">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Model</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {device?.model !== "" ? device?.model : '-'}</p>
                                                    </div>
                                                </div>
                                                <div className="w-1/3 px-6">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Serial Number</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {device?.serial_number !== "" ? device?.serial_number : '-'}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex justify-between mb-[30px]">
                                                <div className="w-1/3 px-6">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Warranty Period</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {device?.warranty_period !== "" ? device?.warranty_period : '-'}</p>
                                                    </div>
                                                </div>
                                                <div className="w-1/3 px-6">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Purchase Date</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {device?.purchase_date === "" ? '-' : moment(device?.purchase_date).format("MM/DD/YYYY")}</p>
                                                    </div>
                                                </div>
                                                <div className="w-1/3 px-6">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Original Location</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {device?.original_location !== "" ? device?.original_location : '-'}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex justify-between mb-[30px]">
                                                <div className="w-1/3 px-6">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Service Provider</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {device?.service_provider !== "" ? device?.service_provider : '-'}</p>
                                                    </div>
                                                </div>
                                                <div className="w-1/3 px-6">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Service Period</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {device?.service_period !== "" ? device?.service_period : '-'}</p>
                                                    </div>
                                                </div>
                                                <div className="w-1/3 px-6">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Service Activation Date</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {device?.service_activation_date === "" ? '-' : moment(device?.service_activation_date).format("MM/DD/YYYY")}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="w-full px-6 mb-[30px]">
                                                <p className="text-sm font-normal text-[#000]">Description</p>
                                                <p className="text-base h-[67px] overflow-auto text-normal text-[#000B17] pt-2 break-words">
                                                    {device?.description !== "" ? device?.description : '-'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>))} 
                {items.length>0&&isLoading&&<div className="flex justify-center"><BeatLoader color='#972E4C'/></div>}
                {items?.length===0&&!isLoading&&<div className='bg-white rounded-lg py-3 px-6 h-calc[100vh-370px] flex flex-col justify-center items-center'>
                    <img src="/images/emptyscreen_img.png" alt="emptyscreen" className="mx-auto"/>
                    <p className="text-center text-xl font-normsl text-[#000]">No devices linked yet</p>
                </div>}
            </div>
        </div>
    )
}